export default __webpack_public_path__ + "static/ux-149e5de40a8b26db55899d36da13da0b.jpg";